
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[communitySlug]/events",
      function () {
        return require("private-next-pages/community/[communitySlug]/events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[communitySlug]/events"])
      });
    }
  